var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6381-black",
    "data-name": "Group 6381",
    transform: "translate(-1568 -205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14829-black",
    "data-name": "Path 14829",
    d: "M49.5,0A49.5,49.5,0,1,1,0,49.5,49.5,49.5,0,0,1,49.5,0Z",
    transform: "translate(1568 205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-black",
    "data-name": "Icon ionic-ios-close",
    d: "M44.523,38.152,63.717,18.958a4.5,4.5,0,1,0-6.36-6.36L38.162,31.791,18.968,12.6a4.5,4.5,0,1,0-6.36,6.36L31.8,38.152,12.608,57.346a4.5,4.5,0,1,0,6.36,6.36L38.162,44.512,57.357,63.706a4.5,4.5,0,1,0,6.36-6.36Z",
    transform: "translate(1579.734 215.849)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBlack);
export default __webpack_public_path__ + "static/media/icon_close_black.aa0a4229.svg";
export { ForwardRef as ReactComponent };